/**
 * 🧩 The puzzle ladder's length — shared (v4.02) because BOTH sides
 * score against it: the app builds and totals the levels, and the
 * puzzle leaderboard route validates claims and computes the stored
 * score. When the ladder grew 25 → 50 (v3.74) only the app side moved:
 * the server kept validating highestLevel ≤ 25 — silently rejecting
 * every submission from a player past level 25 (the board looked
 * "stuck") — and scoring 25-based, so the score on a player's screen
 * disagreed with the board's by exactly 25.
 */
export const PUZZLE_LEVEL_COUNT = 50
